import { render, staticRenderFns } from "./AppLibraryChoiceResume.vue?vue&type=template&id=0618f974"
import script from "./AppLibraryChoiceResume.vue?vue&type=script&lang=js"
export * from "./AppLibraryChoiceResume.vue?vue&type=script&lang=js"
import style0 from "./AppLibraryChoiceResume.vue?vue&type=style&index=0&id=0618f974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports